import { APP_CONFIG } from '@config/app.config';
import { Avatar, Box, Typography } from '@mui/material';
import { Icon, IconSize } from '@shared/icons';

interface OnboardingStepCardHeaderProps {
  stepNumber?: number;
  title: string;
  subtitle?: string;
  isCompleted: boolean;
  isActive: boolean;
}

export const OnboardingStepCardHeader = ({
  stepNumber,
  title,
  subtitle,
  isCompleted,
  isActive,
}: OnboardingStepCardHeaderProps) => {
  const colors = APP_CONFIG.ui.theme.colors;
  const showAvatar = stepNumber !== undefined || isCompleted;

  return (
    <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
      {showAvatar && (
        <Avatar
          sx={{
            width: 40,
            height: 40,
            fontSize: 14,
            fontWeight: 500,
            bgcolor: isCompleted ? colors.primary : 'background.paper',
            color: isCompleted
              ? colors.buttonContent
              : isActive
                ? colors.primary
                : colors.secondaryText,
            border: isCompleted
              ? 'none'
              : isActive
                ? `0.5px solid ${colors.primary}`
                : `0.5px solid ${colors.border}`,
          }}
        >
          {isCompleted ? (
            <Icon icon="Check" size={IconSize.LARGE} color={colors.buttonContent} />
          ) : (
            stepNumber
          )}
        </Avatar>
      )}
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography
          sx={{
            fontWeight: 600,
            fontSize: 18,
            lineHeight: '20px',
            color: colors.primaryText,
          }}
        >
          {title}
        </Typography>
        {subtitle && (
          <Typography
            sx={{
              fontWeight: 400,
              fontSize: 14,
              lineHeight: '20px',
              color: colors.secondaryText,
              mt: showAvatar ? 0 : 0.5,
            }}
          >
            {subtitle}
          </Typography>
        )}
      </Box>
    </Box>
  );
};
